import { render, staticRenderFns } from "./SLMigrateBanner.vue?vue&type=template&id=0bc9e949&scoped=true"
import script from "./SLMigrateBanner.vue?vue&type=script&lang=js"
export * from "./SLMigrateBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc9e949",
  null
  
)

export default component.exports